export enum DestroyStepEnum {
    Parameters = 0,
    Automation,
    Confirmation,
    Instructions,
    Done,
    Error,
}
